import { toast } from 'react-toastify'
import { ky } from './client'

/**
 * Assigns a plan to user.
 *
 * @param {*} userId - The ID of the user to assign a plan to.
 * @param {*} planId - The ID of the plan being assigned.
 */
export const createAssignment = async (userId, planId, deadlineDate = undefined) => {
  if (!planId) return

  return await ky.post('assignments/plans/' + planId, {
    json: { userId, deadlineDate }
  })
}

/**
 * Fetches the assignment user list, with user stats and total stats.
 *
 * @param {Object} pagination - Pagination details.
 * @param {string} pagination.search - An email/name search string.
 * @param {number} pagination.pageNumber - Page number.
 * @param {number} pagination.pageSize - Page size.
 *
 * @returns
 */
export const getAssignmentUserList = async (pagination) => {
  // Convert pagination into valid searchParams
  const searchParams = new URLSearchParams()

  Object.entries(pagination).forEach(([key, value]) => {
    // Handle --> assignments/users?createdAtRange=2025-08-18&createdAtRange=2025-08-28
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(key, v))
    } else if (value !== undefined && value !== null) {
      searchParams.set(key, value)
    }
  })

  try {
    const request = await ky.get('assignments/users', {
      searchParams
    })
    return await request.json()
  } catch (error) {
    console.log(error)
    toast('Unable to view users to assign. Please try again later.', {
      type: 'warning'
    })
    return {
      count: 0,
      rows: [],
      stats: {}
    }
  }
}

/**
 * Fetches a list of plans.
 *
 * @param {Object} pagination - Pagination details.
 * @param {string} pagination.search - An email/name search string.
 * @param {number} pagination.pageNumber - Page number.
 * @param {number} pagination.pageSize - Page size.
 *
 * @returns
 */
export const getAssignmentPlanList = async (pagination) => {
  try {
    const request = ky.get('plans', {
      searchParams: pagination
    })
    const data = await request.json()
    return { count: data.count, rows: data.rows }
  } catch (error) {
    console.log(error)
    toast('Unable to view plans to assign. Please try again later.', {
      type: 'warning'
    })
    return {
      count: 0,
      rows: []
    }
  }
}
